<mat-tab-group [selectedIndex]="tabIndex">
  <mat-tab label="{{ 'tuition' | translate }}">
    <div class="tab-content auto-size">
      @if (tuitionId) {
        <section class="sectionButton" fxLayout="row" fxLayoutGap="16px" fxLayoutGap.xs="8px">
          @if (status === 0) {
            <button class="schooling play_circle_outline" mat-raised-button color="primary"
              (click)="open()">
              <mat-icon>play_circle</mat-icon>
              <span>{{ 'startSchooling' | translate }}</span>
            </button>
          }
          <button class="schooling" mat-raised-button color="primary" (click)="openPrint()">
            <mat-icon>print</mat-icon>
            <span>{{ 'printTuition' | translate }}</span>
          </button>
          <button class="schooling" mat-raised-button color="primary" (click)="openTopicPrint()">
            <mat-icon>print</mat-icon>
            <span>{{ 'printTopic' | translate }}</span>
          </button>
        </section>
      }
      @if (formGroup) {
        <form [formGroup]="formGroup" (submit)="submitForm()">
          <mat-card appearance="outlined">
            <h2 mat-dialog-title>{{ 'tuition' | translate }}</h2>
            <mat-card-content class="block-fields">
              <saf-employee-select class="half-width" [multiple]="false" formControlName="assigneeEmployeeId"
                                   placeholder="{{ 'creator' | translate }}"></saf-employee-select>

              <saf-date-select formControlName="created" class="half-width"
                               placeholder="{{ 'created' | translate }}"></saf-date-select>

              <saf-department-select (valueChangeCompanyId)="getCompany($event)" class="half-width" [required]="true"
                                     [disabled]="true" placeholder="{{ 'section' | translate }}"
                                     formControlName="organiserCompanyId"></saf-department-select>

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{ 'maxParticipants' | translate }}</mat-label>
                <input type="number" matInput formControlName="maxParticipants" autocomplete="disabled">
              </mat-form-field>

              <saf-topic-select [tuition]="true" [disabled]="!!tuitionId" (valueChangeTopic)="getTopicId($event)"
                class="{{tuitionId ? 'half-width' : 'full-width'}}" formControlName="topicId" required></saf-topic-select>

              @if (!tuitionId) {
                <saf-employee-select (valueChange)="getMaxParticipants($event)" [disabled]="!topicId"  [tuitionTopicId]="topicId" class="full-width" [multiple]="true" placeholder="{{'participant'|translate}}"
                                     formControlName="participants"></saf-employee-select>
              }

              @if (tuitionId) {
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>{{ 'status' | translate }}</mat-label>
                  <mat-select [disabled]="true" formControlName="status">

                    <mat-select-trigger>
                      @switch (formGroup.get('status')?.value) {
                        @case (0) {
                          <mat-icon class="saf-color-red">brightness_1</mat-icon>
                          <span>{{ 'open' | translate }}</span>
                        }
                        @case (1) {
                          <mat-icon class="saf-color-green">brightness_1</mat-icon>
                          <span>{{ 'done' | translate }}</span>
                        }
                        @case (2) {
                          <mat-icon class="saf-color-violet">brightness_1</mat-icon>
                          <span>{{ 'cancelled' | translate }}</span>
                        }
                      }
                    </mat-select-trigger>

                    <mat-option [value]="0">
                      <mat-icon class="saf-color-red">brightness_1</mat-icon>
                      <span>{{ 'open' | translate }}</span>
                    </mat-option>

                    <mat-option [value]="1">
                      <mat-icon class="saf-color-green">brightness_1</mat-icon>
                      <span>{{ 'done' | translate }}</span>
                    </mat-option>

                    <mat-option [value]="2">
                      <mat-icon class="saf-color-violet">brightness_1</mat-icon>
                      <span>{{ 'cancelled' | translate }}</span>
                    </mat-option>

                  </mat-select>
                </mat-form-field>
              }

              @if (!allow.checked) {
                <saf-employee-select  class="half-width" [multiple]="false" placeholder="{{'lecturerEmployee'|translate}}"
                                      formControlName="lecturerEmployeeId" [required]="true"
                                      [disabled]="tuitionDetails.tuition.status === 1"></saf-employee-select>
              }

              <mat-slide-toggle class="{{allow.checked ? 'full-width' : 'half-width'}}" #allow
                                [checked]="tuitionDetails.tuition.externalLecturerId"
                                (change)="changeValidation($event.checked)">
                {{ 'allowExternalLecturer' | translate }}
              </mat-slide-toggle>

              @if (allow.checked) {
                <saf-external-company-select placeholder="{{ 'externalCompany' | translate }}"
                                             formControlName="organiserExternalCompanyId" [required]="true"
                                             class="half-width"></saf-external-company-select>
              }
              @if (allow.checked) {
                <saf-external-company-employee-select placeholder="{{ 'externalLecturer' | translate }}"
                                                      formControlName="externalLecturerId" [required]="true"
                                                      class="half-width"></saf-external-company-employee-select>
              }

              <saf-date-select [required]="requiredForm" formControlName="tuitionDate" [disabled]="tuitionDetails.tuition.status === 1"
              class="half-width" placeholder="{{ 'tuitionDate' | translate }}"></saf-date-select>
              <saf-time-input [required]="requiredForm" formControlName="tuitionTime" [disabled]="tuitionDetails.tuition.status === 1"
              placeholder="{{ 'tuitionTime' | translate }}" class="half-width"></saf-time-input>
              <saf-area-location-select (valueChange)="getLocation($event)" [disabled]="!companyId || tuitionDetails.tuition.status === 1"
                [companyId]="companyId" class="half-width"
              formControlName="locationId"></saf-area-location-select>
              <saf-area-room-select [disabled]="!locationId || tuitionDetails.tuition.status === 1" [locationId]="locationId" class="half-width"
              formControlName="roomId"></saf-area-room-select>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'targetSchooling' | translate }}</mat-label>
                <textarea cdkTextareaAutosize matInput formControlName="description" autocomplete="disabled"></textarea>
              </mat-form-field>
              <mat-slide-toggle formControlName="acceptsParticipants" [disabled]="tuitionDetails.tuition.status === 1"
                class="full-width">{{ 'acceptsParticipants' | translate }}
              </mat-slide-toggle>
            </mat-card-content>
          </mat-card>
          <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="end" class="action-buttons" fxLayout.xs="column">
            <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign.xs="space-between">
              @if (tuitionDetails.tuition.status === 0 && tuitionId) {
                <button class="schooling saveButtonHover" type="button"
                  color="primary" mat-raised-button (click)="finish()" fxFlex.xs="0 0 calc(50% - 4px)">
                  <mat-icon>check</mat-icon>
                  <span>{{ 'finish' | translate }}</span>
                </button>
              }
              <button class="schooling deleteButtonHover" color="primary" mat-raised-button type="button"
                (click)="closeForm()" fxFlex.xs="0 0 calc(50% - 4px)">{{ 'cancel' | translate }}
              </button>
            </div>
            <button class="schooling saveButtonHover" mat-raised-button type="submit" (click)="setCloseFlag(false)"
              color="primary" fxFlex.xs="0 0 calc(50% - 4px)">{{ 'save' | translate }}
            </button>
            <button class="schooling saveCloseButtonHover" mat-raised-button type="submit" (click)="setCloseFlag(true)"
              color="primary" fxFlex.xs="0 0 calc(50% - 4px)">{{ 'saveAndClose' | translate }}
            </button>
          </div>
        </form>
      }
    </div>
  </mat-tab>
  <mat-tab [disabled]="!tuitionId">
    <ng-template matTabLabel>
      <span matTooltip="{{ 'saveTuitionToOpenTab' | translate }}"
      [matTooltipDisabled]="!!tuitionId">{{ 'participants' | translate }}</span>
    </ng-template>
    <div class="tab-content">
      @if (tuitionId && tuitionDetails) {
        <saf-schooling-tuition-details-participants [tuitionStatus]="status"
          [acceptMember]="tuitionDetails.tuition.acceptsParticipants"
          [tuitionDetails]="tuitionDetails"
          [tuitionId]="tuitionId" [topicId]="topicId"
        [assigneeEmployeeId]="assigneeEmployeeId"></saf-schooling-tuition-details-participants>
      }
    </div>
  </mat-tab>
  <mat-tab [disabled]="!tuitionId">
    <ng-template matTabLabel>
      <span matTooltip="{{ 'saveTuitionToOpenTab' | translate }}"
      [matTooltipDisabled]="!!tuitionId">{{ 'fileAttachments' | translate }}</span>
    </ng-template>
    <div class="tab-content auto-size">
      @if (tuitionId) {
        <saf-file-management-panel [dataId]="tuitionId" [listModules]="['group']" [hasPermission]="hasPermission"
        uploadModule="group"></saf-file-management-panel>
      }
    </div>
  </mat-tab>
</mat-tab-group>

